(() => {
  if (window.WubCollectionShoppingFlowV21) return;

  const openerByRoot = new WeakMap();
  const qs = (root, selector) => root ? root.querySelector(selector) : null;
  const qsa = (root, selector) => root ? Array.from(root.querySelectorAll(selector)) : [];
  const getRoot = (node) => node && node.closest ? node.closest('[data-wub-collection]') : null;

  function usesDrawer(root) {
    return !!root && (window.matchMedia('(max-width: 1024px)').matches || root.classList.contains('wub-collection-v2--facets-drawer'));
  }

  function focusables(container) {
    return qsa(container, 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
      .filter((element) => element.offsetParent !== null && element.getAttribute('aria-hidden') !== 'true');
  }

  function rememberOpener(root, opener) {
    if (root && opener) openerByRoot.set(root, opener);
  }

  function restoreOpener(root) {
    const opener = root ? openerByRoot.get(root) : null;
    if (!opener || !opener.isConnected) return;
    requestAnimationFrame(() => opener.focus({ preventScroll: true }));
  }

  function markDrawerDirty(root, dirty) {
    if (!root) return;
    if (dirty) root.dataset.filtersDirty = 'true';
    else root.removeAttribute('data-filters-dirty');
    const apply = qs(root, '.wub-facets__apply');
    if (apply) apply.classList.toggle('is-dirty', !!dirty);
  }

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target || !target.matches('[data-wub-filter-input]')) return;
    const root = getRoot(target);
    if (!root || !usesDrawer(root)) return;

    /* In a drawer, filters are deliberately multi-select. The existing V2
       listener auto-submits checkboxes; stop that listener until Apply. */
    event.stopImmediatePropagation();
    markDrawerDirty(root, true);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-wub-filter-form]');
    if (!form) return;
    const root = getRoot(form);
    if (root) markDrawerDirty(root, false);
  }, true);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest?.('[data-wub-filter-open], [data-wub-sticky-action="filter"]');
    if (opener) {
      const root = getRoot(opener);
      if (root) rememberOpener(root, opener);
      return;
    }

    const closer = event.target.closest?.('[data-wub-filter-close]');
    if (closer) {
      const root = getRoot(closer);
      if (root) restoreOpener(root);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    const root = qs(document, '[data-wub-collection][data-filters-open="true"]');
    if (!root) return;

    if (event.key === 'Escape') {
      restoreOpener(root);
      return;
    }

    if (event.key !== 'Tab') return;
    const drawer = qs(root, '.wub-facets');
    const items = focusables(drawer);
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  window.WubCollectionShoppingFlowV21 = { usesDrawer };
})();
